module.exports = __webpack_public_path__ + "img/soa.f96ae27c.svg";